package com.ives.components.measpopup;

import com.er453r.hxcompo.Component;
import com.ives.components.messagehandler.MessageHandler;
import com.ives.components.popup.Popup;

class MeasurementPopup extends Component {
    private var type:String;
    private var values:Array<String>;

    public function new(type:String, values:Array<String>) {
        this.type = type;
        this.values = values;

        on(closeButton, "click", close);

        on(cursorButton, "click", sendCursor);
        on(variableButton, "click", sendVariable);
    }

    private function sendCursor() {
        MessageHandler.send(new MeasData(type, "cursor", values));

        dispatch(Popup.CLOSE);
    }

    private function sendVariable() {
        MessageHandler.send(new MeasData(type, "variable", values));

        dispatch(Popup.CLOSE);
    }

    private function close() {
        dispatch(Popup.CLOSE);
    }

    public function open() {
        new Popup(this).open("#viewer");
    }
}

class MeasData {
    public var type:String;
    public var selection:String;
    public var data:Array<String>;

    public function new(?type:String, ?selection:String, ?data:Array<String>) {
        this.type = type;
        this.selection = selection;
        this.data = data;
    }
}
